import * as CarbonComponents from '@carbon/react';
export const Grid = CarbonComponents.Grid;
export const FlexGrid = CarbonComponents.FlexGrid;
export const Row = CarbonComponents.Row;
export const Column = CarbonComponents.Column;
